import { useContext } from 'react';
import { PdfContext } from 'utils/context';
import { getColorByName } from 'utils/culturesColors';
import { getCultureGrossMargin, loadResultMapTabData, sortList } from 'utils/Map/MapTabUtils';
import './table.style.scss';
import TotalMapTab from 'components/generics/Map/TotalMapTab';
import bioLogo from 'assets/images/bio.png';
import conversionLogo from 'assets/images/conversionLogo.png';
import { useTranslation } from 'react-i18next';

type cropsGrossMarginType = {
  dataGrossMargin: any;
  yearIndex: number;
  filterType: any;
};
type culture = {
  id: number;
  name: String;
  color: string;
  irrigationWaterNeeded: number;
  isArable: boolean | null;
  year: number;
  surface: number;
  organicState: string | null;
};

const CropGrossMarginTable = ({ yearIndex, filterType = null }: cropsGrossMarginType) => {
  const { t } = useTranslation();
  const { suggest, culturesColors, forecastCampaign, previousCropMargin, dataCropGrossMargin } =
    useContext(PdfContext);
  let headers = [
    '',
    t('common.culture'),
    t('simulation.common.margin'),
  ];
  const filteredData = filterType
    ? dataCropGrossMargin?.map((parcel: any) => ({
        ...parcel,
        cultures: parcel.cultures.map((cultureArray: any) =>
          cultureArray.filter((culture: any) => culture.type === filterType),
        ),
      }))
    : dataCropGrossMargin;

  const { allCulturesByYear, totalSurfaceIncrement } = loadResultMapTabData(
    filteredData,
    culturesColors,
    null,
    null,
    false,
  );

  return (
    <div className="cultures-map-tab-container table">
      <div className={'table-container sticky-table table-production'}>
        {!dataCropGrossMargin && (
          <div
            style={{
              fontSize: 'bold',
              fontFamily: 'Rubik',
              padding: '20px',
              color: '#707070',
            }}
          >
            {t('simulation.common.noCulturesForYear')}
          </div>
        )}
        {dataCropGrossMargin && (
          <table className={'cultures-map-tab-table'}>
            <thead
              style={{ fontSize: 'bold', fontFamily: 'Rubik' }}
              className={'table_head sticky-table'}
            >
              <tr>
                {headers.map((header) => (
                  <th
                    key={header}
                    scope="col"
                    className={header === 'Marge (€/ha)' ? 'last_column_name' : 'column_name'}
                    colSpan={
                      header === t('simulation.common.margin') ||
                      header === 'Surface'
                        ? 2
                        : 1
                    }
                  >
                    <span>{header}</span>
                  </th>
                ))}
              </tr>
              {headers.includes('Surface') && (
                <tr className="column_subName">
                  <th colSpan={2}></th>
                  <th colSpan={1}>(ha)</th>
                  <th colSpan={1}>(%)</th>
                  {headers.includes('Marge (€/ha)') && <th colSpan={2}></th>}
                </tr>
              )}
              {headers.includes(t('simulation.common.margin')) && (
                <tr className="column_subName">
                  <th colSpan={2}></th>
                  <th colSpan={1}>(€)</th>
                  <th colSpan={1}>(€ / ha)</th>
                </tr>
              )}
            </thead>
            <tbody>
              {sortList(allCulturesByYear, +forecastCampaign.startYear + yearIndex)
                ?.filter((culture: culture) => culture.id !== undefined)
                .map((culture: culture, i: number) => (
                  <tr key={i} className="tr">
                    <td key={getColorByName(culture.name, culturesColors)}>
                      <div
                        className="culture-color"
                        style={{ background: '#' + getColorByName(culture.name, culturesColors) }}
                      ></div>
                    </td>
                    <>
                      <td className="crop_cell" key={culture.name as string}>
                        {culture.name}
                        {culture?.organicState === 'conversion' ? (
                          <img src={conversionLogo} alt="Logo organic" />
                        ) : culture?.organicState === 'organic' ? (
                          <img src={bioLogo} alt="Logo organic" />
                        ) : null}
                      </td>
                      <td key={'marge_total'}>
                        {getCultureGrossMargin(
                          culture,
                          previousCropMargin,
                          yearIndex,
                          suggest.years,
                        )}
                      </td>
                      <td key={'marge_ha'}>
                        {getCultureGrossMargin(
                          culture,
                          previousCropMargin,
                          yearIndex,
                          suggest.years,
                          culture.surface,
                        )}
                      </td>
                    </>
                  </tr>
                ))}
            </tbody>
          </table>
        )}
        <TotalMapTab totalSurface={totalSurfaceIncrement} fromProduction={true} />
      </div>
    </div>
  );
};

export default CropGrossMarginTable;
